import React, { useState } from 'react';

function FormComponent() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        message: '',
    });

    const handleSubmit = (event) => {
        event.preventDefault();

        // Check if name and phone are filled
        if (!formData.name || !formData.phone) {
            alert('Please enter your name and phone number.');
            return;
        }

        // Make a POST request to the getform.io API endpoint
        fetch('https://getform.io/f/76d3abb7-3407-4c6f-8a1b-113f21d098f1', {
            method: 'POST',
            body: new FormData(event.target),
        })
            .then((response) => {
                if (response.ok) {
                    // Reset the form and show success alert
                    setFormData({ name: '', phone: '', message: '' });
                    // Redirect to thank-you page
                    window.location.href = 'https://getform.io/thank-you';
                } else {
                    throw new Error('Form submission failed.');
                }
            })
            .catch((error) => {
                // Handle any errors
                console.error('Form submission error:', error);
                alert('Form submission failed. Please try again later.');
            });
    };

    const handleChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
    };

    return (
        <div>
            <form id="contact_form"
                action="https://getform.io/f/76d3abb7-3407-4c6f-8a1b-113f21d098f1"
                method="POST"
                onSubmit={handleSubmit} className="flex flex-col py-6 w-[85%] mx-auto space-y-6  md:px-6 ng-untouched ng-pristine ng-valid" dir='rtl'>
                <label className="block">
                    <span className="p-2 font-medium text-main">שם</span>
                    <input type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="שם מלא"
                        required className="block w-full p-2 mt-1 rounded-md shadow-sm  " />
                </label>
                <label className="block">
                    <span className="p-2 font-medium text-main">טלפון</span>
                    <input type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="מספר טלפון"
                        required className="block w-full p-2 mt-1 rounded-md shadow-sm  " />
                </label>
                <label className="block">
                    <span className="p-2 font-medium text-main">הודעה (לא חובה)</span>
                    <textarea name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="הודעה" className="block w-full p-2 mt-1  rounded-md   "></textarea>
                </label>
                <button
                    className="px-4 py-1.5 rounded-md shadow-lg  bg-gradient-to-l from-mainBtn to-secondaryBtn font-medium  text-white block hover:opacity-80 hover:text-grey-900 duration-200 "
                    type="submit"
                >
                    <span id="contact_process_state" className="hidden">
                        Sending :)
                    </span>
                    <span id="contact_default_state">שליחה</span>
                </button>
            </form>

        </div>

    );
}

export default FormComponent;
